// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageHeader from './PageHeader'
import Content from './Content'
import Posts from './Posts'

class Page extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const { params } = this.props.match
		document.title = page.title.raw

		let showPageHeader = false

		const pageContent = page.html_override ? (
			<div className="content-custom-wrap" dangerouslySetInnerHTML={ { __html: page.html_override } }></div>
		) : (
			<div>
				{ showPageHeader &&
					<PageHeader />
				}

				{ 'contact' == page.template &&
					<div className="contact-card">
						<div className="-profile">
							<img src={ `${siteData.images_url}header/anicoop-chickens.png` } alt="" />
						</div>

						<div className="-items">
							<div className="-item">
								<i className="icon-location" />

								<p>289 Maroondah Hwy (PO Box 4368), Ringwood VIC, 3134</p>
							</div>

							<div className="-item">
								<i className="icon-phone" />

								<p>03 9871 7555</p>
							</div>

							<div className="-item">
								<i className="icon-mail" />

								<p>info@animationcoop.org.au</p>
							</div>
						</div>
					</div>
				}

				<Content />

				{ 'blog' == page.template && <Posts { ...this.props } /> }
			</div>
		)

		return (
			<div className="primary-content-inner primary-content-is-ready">
				{ pageContent }
			</div>
		)
	}

	render() {
		const { isLoading } = this.props

		return (
			<div>
				{ isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isLoading: state.page.isLoading,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( Page )



// WEBPACK FOOTER //
// ./views/pages/basic-page/Page.jsx